const validEmailRegex = RegExp(/^[A-Z0-9][A-Z0-9._%+-]{0,63}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/i)

const validateEmail = (value: string): boolean => {
    return validEmailRegex.test(value);
}

const validateDateAfterToday = (value: string) => {
    const date = new Date(value);
    const today = new Date();

    if (date.getTime() && date > today) {
        return true
    } else return false
}
const validateEnv = (value: string) => {
    if (value === 'staging') {
        return true
    } else return value === 'production';
}


const validators = {
    validateEmail,
    validateDateAfterToday,
    validateEnv
}

export default validators;
